/* WHOLESALE CATALOGUE — quick add.
   IIFE, not a custom element: the WB layer deliberately has none.

   ⚠ Reads /cart.js BEFORE adding so the requested quantity can be clamped by
   what is ALREADY in the cart. A quantity that is fine on its own still 422s
   when the same variant is sitting in the cart and the two together exceed
   stock — same reasoning as assets/wb-trade-quote.js and wb-kit-builder.js.

   ⚠ Does NOT open the cart drawer. A trade buyer works down a price book adding
   many lines; popping the drawer on every add would fight them. The button
   confirms in place and 'cart:refresh' updates the count silently. */
(function () {
  var ADD = (window.FoxTheme && FoxTheme.routes && FoxTheme.routes.cart_add_url) || '/cart/add';
  var CART = (window.FoxTheme && FoxTheme.routes && FoxTheme.routes.cart_url) || '/cart';

  var root = function () { return document.querySelector('.wb-wsc'); };
  var msg = function (key, fallback) {
    var r = root();
    return (r && r.getAttribute('data-msg-' + key)) || fallback;
  };

  var flash = function (btn, text, isError) {
    btn.textContent = text;
    btn.classList.toggle('is-error', !!isError);
    btn.classList.toggle('is-done', !isError);
    window.setTimeout(function () {
      btn.textContent = btn.getAttribute('data-label');
      btn.classList.remove('is-done', 'is-error');
      btn.disabled = false;
      btn.removeAttribute('aria-busy');
    }, 1800);
  };

  var add = function (btn) {
    var id = parseInt(btn.getAttribute('data-variant-id'), 10);
    var ceiling = parseInt(btn.getAttribute('data-ceiling'), 10);
    if (!id) return;

    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');
    btn.textContent = msg('adding', 'Adding…');

    fetch(CART + '.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : { items: [] }; })
      .catch(function () { return { items: [] }; })
      .then(function (cart) {
        var have = 0;
        (cart.items || []).forEach(function (it) {
          if (it.variant_id === id) have += it.quantity;
        });
        if (ceiling >= 0 && have >= ceiling) {
          flash(btn, msg('max', 'All stock is in your cart'), true);
          return null;
        }
        return fetch(ADD, {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
        }).then(function (r) {
          return r.json().then(function (b) { return { ok: r.ok, body: b }; });
        });
      })
      .then(function (out) {
        if (!out) return;
        if (!out.ok || (out.body && out.body.status)) {
          flash(btn, (out.body && out.body.description) || msg('failed', 'Could not add'), true);
          return;
        }
        flash(btn, msg('added', 'Added'), false);
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: false } }));
      })
      .catch(function () { flash(btn, msg('failed', 'Could not add'), true); });
  };

  /* Delegated, so pagination or any future re-render needs no rebinding. */
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('[data-wsc-add]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    add(btn);
  });
})();
